// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'DepEd loans'"></sub-header>

  <div>
    <dynamic-list
        columns="\$ctrl.columns"
        data="\$ctrl.transactions" ></dynamic-list>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/deped/batch-deped-transaction-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;